const messages = {
  subtitle: "Møt Bridgestone-teamet vårt",
  title: "Kundeservice",
  description: "Velkommen til kundeservice",
  teams: {
    direct: "Direkte",
    indirect: "Indirekte",
    tyre: "Dekkhandelteam",
    car: "Bilforhandlerteam",
    lkw: "Lastbilteam",
    em_otr: "EM/OTR-team",
    farm_tractor: "Landbrukstraktorteam",
    bandag: "Bandag-team",
  },
  contact: {
    index: {
      title: "",
      description: "",
    },
    categories: {
      service: {
        description: "",
      },
      touch: {
        title: "",
        description: "",
      },
      contact: {
        short_desc: "",
      },
    },
    strategicPartners: {
      cardTitle: "",
      short_desc: "",
    },
  },
};

export default {
  messages,
};
